import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.CTVRegistration {
  z-index: 4;
  background-color: ${colors.darkPurple};
  color: ${colors.white};
}
.inner {
  display: flex;
  justify-content: center;
  text-align: center;
  position: relative;
  max-width: 1024px;
  margin: 0 auto;
  padding: 10px;
}
.CTVRegistration .link {
  color: ${colors.white};
  text-decoration: underline;
  -webkit-font-smoothing: auto;
}
`
